const predictorRoutes = [
  {
    path: '',
    component: () => import('@/app/shared/layouts/main/Main.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/orbit/predictor',
        name: 'orbitPredictor',
        component: () => import('./views/Predictor.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'dem-for' },
            { title: 'dashboard', active: true },
          ],
          pageTitle: 'DemFor',
          rule: 'editor'
        }
      }
    ]
  }
];

export default predictorRoutes;
